<div class="content">

    <div class="text-left mt-5">


        <h3>Submit Video Job using public url (Optimization/Upscaling)</h3> <br><br>

        <p><b>A job information object</b></p><br>

        <div class="table-responsive">
            <table class="table table-primary table-bordered">
                <tbody>

                    <tr>
                        <td>
                            <h6>input_url</h6>
                        </td>
                        <td colspan="4">
                            <p>
                                Create Job. Before calling this API, a request must be made to [Create S3 Presigned URL]
                                api and subsequent PUT request has to be done on 'presigned_url' which obtained from
                                response of [Create S3 Presigned URL] Api.
                            </p>
                            <p>
                                Public input file url has to be given if input_access_mode is selected as public
                            </p>
                        </td>
                    </tr>


                    <tr>
                        <td>
                            <h6>crunch_mode</h6>
                        </td>
                        <td colspan="4">
                            <small>string</small>
                            <p>
                                Enum: "upscaler_2x" "upscaler_4x" "optimizer"
                                [Optional],[Default: optimizer] If upscaler_2x is selected then input video will be
                                upscaled to 2 * original video resolution. If upscaler_4x is selected then input video
                                will be upscaled to 4 * original video resolution. If optimizer is selected then video
                                will be optimized
                            </p>
                        </td>
                    </tr>


                    <tr>
                        <td>
                            <h6>input_access_mode</h6>
                        </td>
                        <td colspan="4">
                            <small>string</small>
                            <p>
                                Enum: "public" "private"
                                Currently only "public" supported
                            </p>
                        </td>
                    </tr>


                    <tr>
                        <td>
                            <h6>output_access_mode</h6>
                        </td>
                        <td colspan="4">
                            <small>string</small>
                            <p>
                                Enum: "public" "private"
                                Currently only "public" supported
                            </p>
                        </td>
                    </tr>

                    <tr>
                        <td>
                            <h6>output_video_code</h6>
                        </td>
                        <td colspan="4">
                            <small>string</small>
                            <p>
                                Enum: "hevc" "h264"
                                [Mandatory]. Output Video Codec allows the customers to select the preferred ouput video
                                codec.
                            </p>
                        </td>
                    </tr>

                    <tr>
                        <td>
                            <h6>abr_type</h6>
                        </td>
                        <td colspan="4">
                            <small>string</small>
                            <p>
                                Enum: "NONE" "HLS_MP4" "HLS_TS"
                                [Optional],[Default: NONE]. Adaptive Bitrate Type allows the customers to select the
                                preferred Segment Types. If the value is set as NONE, No HLS segments will be generated.
                                If user selects HLS_MP4 then mp4 segements will be generated in the output. If user
                                selects HLS_TS then transport stream segements will be generated in the output.
                            </p>
                        </td>
                    </tr>


                </tbody>
            </table>
        </div><br>



        <div class="card text-bg-dark mb-3">
            <div class="card-body">
                <pre><button type="button" class="btn btn-success">POST</button>  https://api.optimusdrive.ai/vod/v1/video/job</pre>
            </div>
        </div> <br><br>


        <h5>Example Request</h5><br>

        <div class="card text-bg-dark mb-3">
            <div class="card-body">
    
                <div class="card-title">
                    <button style="float: right;" *ngIf="copyButton" class="btn btn-outline-primary btn-sm" (click)="copyJsonToClipboard()">
                      <i class="fa fa-clipboard" aria-hidden="true"></i>
                    </button>
                      
                    <button style="float: right;" *ngIf="copiedButton"  class="btn btn-success btn-sm">
                      Copied <i class="fa fa-check" aria-hidden="true"></i>
                    </button>
              
                   </div><br><br>
                   
                <pre><code [innerHTML]="requestData"></code></pre>
            </div>
        </div><br><br>


        <div>

            <h5>Example Response</h5><br>
    
    
            <div class="card text-bg-light mb-3">
                <div class="card-body">
    
                    <div class="panel panel-primary">
                        <div class="tab-menu-heading">
                            <ul class="nav nav-pills" role="tablist">
                                <!-- Tab menu items -->
                                <li class="nav-item" role="presentation">
                                    <button class="nav-link active" id="tab1" data-bs-toggle="tab"
                                        data-bs-target="#content1" type="button" role="tab" aria-controls="content1"
                                        aria-selected="true">200</button>
                                </li>
                                <li class="nav-item" role="presentation">
                                    <button class="nav-link" id="tab2" data-bs-toggle="tab" data-bs-target="#content2"
                                        type="button" role="tab" aria-controls="content2"
                                        aria-selected="false">401</button>
                                </li>
                                <li class="nav-item" role="presentation">
                                    <button class="nav-link" id="tab3" data-bs-toggle="tab" data-bs-target="#tent3"
                                        type="button" role="tab" aria-controls="content3"
                                        aria-selected="false">500</button>
                                </li>
                            </ul>
                        </div>
    
                        <div class="panel-body tabs-menu-body mt-4">
                            <div class="tab-content">
                                <!-- Tab content -->
                                <div class="tab-pane fade show active" id="content1" role="tabpanel"
                                    aria-labelledby="tab1">
                                    <div class="card-body">
                                        <pre><code [innerHTML]="sucessData" ></code></pre>
                                    </div>
                                </div>
                                <div class="tab-pane fade" id="content2" role="tabpanel" aria-labelledby="tab2">
                                    <div class="card-body">
                                        <pre><code [innerHTML]="Error401x" ></code></pre>
                                    </div>
                                </div>
    
                                <div class="tab-pane fade" id="tent3" role="tabpanel" aria-labelledby="tab3">
    
                                    <div class="card-body" id="content3">
                                       <p>An internal server error</p>
                                    </div><br>
    
                                </div>
    
                            </div>
                        </div>
                    </div>
    
                </div>
            </div>
    
    
        </div><br><br><br>











    </div>

</div>